import { FRIENDS_FETCH_SUCCESS, FRIENDS_FETCH_ERROR } from './types';
import { baseUrl } from '../constants/baseUrl';

import { fetchWithAccessToken } from './helperAction';

export const fetchFriends = (currentUserID) => async (dispatch) => {
  try {
    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}friendship/friends/${currentUserID}`,
        method: 'GET',
      }),
    );

    const body = await response.json();
    switch (response.status) {
      case 200:
        await dispatch({
          type: FRIENDS_FETCH_SUCCESS,
          payload: body,
        });
        break;
      default:
        await dispatch({
          type: FRIENDS_FETCH_ERROR,
        });
    }
  } catch (e) {
    dispatch({
      type: FRIENDS_FETCH_ERROR,
    });
  }
};
